import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function useContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    organization: "",
    subject: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const change = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await api.post("/contact", form);

      setDone(true);

      toast.success(
        "Message sent. We'll respond within 1 business day."
      );

      setForm({
        name: "",
        email: "",
        organization: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      toast.error(
        err.response?.data?.detail ||
          "Failed to send message."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return {
    form,
    change,
    submit,
    submitting,
    done,
  };
}